import '../../assets/index45.css';var de = Object.defineProperty, me = Object.defineProperties;
var _e = Object.getOwnPropertyDescriptors;
var $ = Object.getOwnPropertySymbols;
var te = Object.prototype.hasOwnProperty, oe = Object.prototype.propertyIsEnumerable;
var ee = (e, t, o) => t in e ? de(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o, s = (e, t) => {
  for (var o in t || (t = {}))
    te.call(t, o) && ee(e, o, t[o]);
  if ($)
    for (var o of $(t))
      oe.call(t, o) && ee(e, o, t[o]);
  return e;
}, p = (e, t) => me(e, _e(t));
var A = (e, t) => {
  var o = {};
  for (var r in e)
    te.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
  if (e != null && $)
    for (var r of $(e))
      t.indexOf(r) < 0 && oe.call(e, r) && (o[r] = e[r]);
  return o;
};
import { jsxs as N, jsx as n, Fragment as Se } from "react/jsx-runtime";
import F, { Children as ue, cloneElement as fe, createElement as ge } from "react";
import { CircleXmarkFarFAIcon as ve, CheckFarFAIcon as he, PenFarFAIcon as Ie } from "../Icons/index.js";
import { ProgressIndicator as ye } from "../ProgressIndicator/index.js";
import { r as Ce } from "../../rem-CMQJ_ZTp.js";
import { b as se, a as be, e as Ne, c as we } from "../../get-size-Bc1Pz5yf.js";
import { c as Pe } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as ne, u as ae, b as Le, h as ce, B as re } from "../../factory-ueRxoNOV.js";
import { g as ke } from "../../get-contrast-color-SC35uhiM.js";
import { g as ze } from "../../get-auto-contrast-value-BGSSZ1GD.js";
import { u as Ee } from "../../use-styles-DToiHEa6.js";
import { c as $e } from "../../create-safe-context-DqDyoPVE.js";
import { C as Ae } from "../../CheckIcon-DkmKiN6y.js";
import { L as pe } from "../../Loader-DVuQGvNU.js";
import { T as Fe } from "../../Transition-esp-rpzm.js";
import { U as Re } from "../../UnstyledButton-D9OCzDhz.js";
const [Be, je] = $e(
  "Stepper component was not found in tree"
), B = () => null;
B.displayName = "@mantine/core/StepperCompleted";
var H = { root: "m_cbb4ea7e", steps: "m_aaf89d0b", separator: "m_2a371ac9", content: "m_78da155d", step: "m_cbb57068", "step--horizontal": "m_f56b1e2c", "step--vertical": "m_833edb7e", verticalSeparator: "m_6496b3f3", stepWrapper: "m_818e70b", stepIcon: "m_1959ad01", stepCompletedIcon: "m_a79331dc", stepBody: "m_1956aa2a", stepLabel: "m_12051f6c", stepDescription: "m_164eea74" };
const R = (e, t) => typeof e == "function" ? /* @__PURE__ */ n(e, { step: t || 0 }) : e, Te = {
  withIcon: !0,
  allowStepClick: !0,
  iconPosition: "left"
}, U = ne((e, t) => {
  const b = ae("StepperStep", Te, e), {
    classNames: o,
    className: r,
    style: v,
    styles: h,
    vars: f,
    step: l,
    state: i,
    color: d,
    icon: m,
    completedIcon: I,
    progressIcon: j,
    label: P,
    description: L,
    withIcon: T,
    iconSize: q,
    loading: V,
    allowStepClick: S,
    allowStepSelect: k,
    iconPosition: z,
    orientation: K,
    mod: D
  } = b, M = A(b, [
    "classNames",
    "className",
    "style",
    "styles",
    "vars",
    "step",
    "state",
    "color",
    "icon",
    "completedIcon",
    "progressIcon",
    "label",
    "description",
    "withIcon",
    "iconSize",
    "loading",
    "allowStepClick",
    "allowStepSelect",
    "iconPosition",
    "orientation",
    "mod"
  ]), c = je(), W = Le(), a = { classNames: o, styles: h }, E = i === "stepCompleted" ? null : i === "stepProgress" ? j : m, y = {
    "data-progress": i === "stepProgress" || void 0,
    "data-completed": i === "stepCompleted" || void 0
  };
  return /* @__PURE__ */ N(
    Re,
    p(s(s(p(s({}, c.getStyles("step", s({ className: r, style: v, variant: c.orientation }, a))), {
      mod: [
        { "icon-position": z || c.iconPosition, "allow-click": S },
        D
      ],
      ref: t
    }), y), M), {
      __vars: { "--step-color": d ? ce(d, W) : void 0 },
      tabIndex: S ? 0 : -1,
      children: [
        T && /* @__PURE__ */ N("span", p(s({}, c.getStyles("stepWrapper", a)), { children: [
          /* @__PURE__ */ N("span", p(s(s({}, c.getStyles("stepIcon", a)), y), { children: [
            /* @__PURE__ */ n(Fe, { mounted: i === "stepCompleted", transition: "pop", duration: 200, children: (x) => /* @__PURE__ */ n(
              "span",
              p(s({}, c.getStyles("stepCompletedIcon", s({ style: x }, a))), {
                children: V ? /* @__PURE__ */ n(
                  pe,
                  s({
                    color: "var(--mantine-color-white)",
                    size: "calc(var(--stepper-icon-size) / 2)"
                  }, c.getStyles("stepLoader", a))
                ) : R(I, l) || /* @__PURE__ */ n(Ae, { size: "60%" })
              })
            ) }),
            i !== "stepCompleted" ? V ? /* @__PURE__ */ n(
              pe,
              p(s({}, c.getStyles("stepLoader", a)), {
                size: "calc(var(--stepper-icon-size) / 2)",
                color: d
              })
            ) : R(E || m, l) : null
          ] })),
          K === "vertical" && /* @__PURE__ */ n(
            "span",
            p(s({}, c.getStyles("verticalSeparator", a)), {
              "data-active": i === "stepCompleted" || void 0
            })
          )
        ] })),
        (P || L) && /* @__PURE__ */ N(
          "span",
          p(s({}, c.getStyles("stepBody", a)), {
            "data-orientation": c.orientation,
            "data-icon-position": z || c.iconPosition,
            children: [
              P && /* @__PURE__ */ n("span", p(s({}, c.getStyles("stepLabel", a)), { children: R(P, l) })),
              L && /* @__PURE__ */ n("span", p(s({}, c.getStyles("stepDescription", a)), { children: R(L, l) }))
            ]
          })
        )
      ]
    })
  );
});
U.classes = H;
U.displayName = "@mantine/core/StepperStep";
const Ve = {
  orientation: "horizontal",
  iconPosition: "left",
  allowNextStepsSelect: !0,
  wrap: !0
}, De = Pe(
  (e, { color: t, iconSize: o, size: r, contentPadding: v, radius: h, autoContrast: f }) => ({
    root: {
      "--stepper-color": t ? ce(t, e) : void 0,
      "--stepper-icon-color": ze(f, e) ? ke({ color: t, theme: e, autoContrast: f }) : void 0,
      "--stepper-icon-size": o === void 0 ? we(r, "stepper-icon-size") : Ce(o),
      "--stepper-content-padding": se(v),
      "--stepper-radius": h === void 0 ? void 0 : Ne(h),
      "--stepper-fz": be(r),
      "--stepper-spacing": se(r)
    }
  })
), w = ne((e, t) => {
  var X, G, J;
  const o = ae("Stepper", Ve, e), Q = o, {
    classNames: r,
    className: v,
    style: h,
    styles: f,
    unstyled: l,
    vars: i,
    children: d,
    onStepClick: m,
    active: I,
    icon: j,
    completedIcon: P,
    progressIcon: L,
    color: T,
    iconSize: q,
    contentPadding: V,
    orientation: S,
    iconPosition: k,
    size: z,
    radius: K,
    allowNextStepsSelect: D,
    wrap: M,
    autoContrast: c
  } = Q, W = A(Q, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "children",
    "onStepClick",
    "active",
    "icon",
    "completedIcon",
    "progressIcon",
    "color",
    "iconSize",
    "contentPadding",
    "orientation",
    "iconPosition",
    "size",
    "radius",
    "allowNextStepsSelect",
    "wrap",
    "autoContrast"
  ]), a = Ee({
    name: "Stepper",
    classes: H,
    props: o,
    className: v,
    style: h,
    classNames: r,
    styles: f,
    unstyled: l,
    vars: i,
    varsResolver: De
  }), E = ue.toArray(d), y = E.filter(
    (C) => C.type !== B
  ), b = E.find(
    (C) => C.type === B
  ), x = y.reduce(
    (C, g, u) => {
      const Y = I === u ? "stepProgress" : I > u ? "stepCompleted" : "stepInactive", Z = typeof m != "function" ? !1 : typeof g.props.allowStepSelect == "boolean" ? g.props.allowStepSelect : Y === "stepCompleted" || D;
      return C.push(
        fe(g, {
          icon: g.props.icon || j || u + 1,
          key: u,
          step: u,
          state: Y,
          onClick: () => Z && (m == null ? void 0 : m(u)),
          allowStepClick: Z,
          completedIcon: g.props.completedIcon || P,
          progressIcon: g.props.progressIcon || L,
          color: g.props.color || T,
          iconSize: q,
          iconPosition: g.props.iconPosition || k,
          orientation: S
        })
      ), S === "horizontal" && u !== y.length - 1 && C.push(
        /* @__PURE__ */ ge(
          "div",
          p(s({}, a("separator")), {
            "data-active": u < I || void 0,
            "data-orientation": S,
            key: `separator-${u}`
          })
        )
      ), C;
    },
    []
  ), le = (G = (X = y[I]) == null ? void 0 : X.props) == null ? void 0 : G.children, ie = (J = b == null ? void 0 : b.props) == null ? void 0 : J.children, O = I > y.length - 1 ? ie : le;
  return /* @__PURE__ */ n(Be, { value: { getStyles: a, orientation: S, iconPosition: k }, children: /* @__PURE__ */ N(re, p(s(p(s({}, a("root")), { ref: t, size: z }), W), { children: [
    /* @__PURE__ */ n(
      re,
      p(s({}, a("steps")), {
        mod: {
          orientation: S,
          "icon-position": k,
          wrap: M && S !== "vertical"
        },
        children: x
      })
    ),
    O && /* @__PURE__ */ n("div", p(s({}, a("content")), { children: O }))
  ] })) });
});
w.classes = H;
w.displayName = "@mantine/core/Stepper";
w.Completed = B;
w.Step = U;
const Me = "Stepper-module__root___lkQO8", We = "Stepper-module__content___cPoEo", xe = "Stepper-module__steps___9EekK", He = "Stepper-module__step___2FjtV", Ue = "Stepper-module__stepIcon___im5Si", qe = "Stepper-module__verticalSeparator___bHR9v", Ke = "Stepper-module__separator___7nq9A", Oe = "Stepper-module__stepLabel___1kg7I", Qe = "Stepper-module__stepLoader___o1IjD", Xe = "Stepper-module__penIcon___odNtM", Ge = "Stepper-module__checkIcon___pWHM0", _ = {
  root: Me,
  content: We,
  steps: xe,
  step: He,
  stepIcon: Ue,
  verticalSeparator: qe,
  separator: Ke,
  stepLabel: Oe,
  stepLoader: Qe,
  penIcon: Xe,
  checkIcon: Ge
}, Je = F.forwardRef((h, v) => {
  var f = h, {
    orientation: e = "horizontal",
    errorSteps: t = [],
    loadingSteps: o = []
  } = f, r = A(f, [
    "orientation",
    "errorSteps",
    "loadingSteps"
  ]);
  return /* @__PURE__ */ n(
    w,
    p(s({
      ref: v,
      classNames: _,
      orientation: e,
      completedIcon: /* @__PURE__ */ N(Se, { children: [
        /* @__PURE__ */ n(he, { className: _.checkIcon }),
        /* @__PURE__ */ n(Ie, { className: _.penIcon })
      ] })
    }, r), {
      children: F.Children.map(r.children, (l, i) => {
        if (!F.isValidElement(l)) return l;
        const d = t.includes(i), m = o.includes(i);
        return F.cloneElement(l, p(s({}, l.props), {
          icon: d ? /* @__PURE__ */ n(ve, {}) : m ? /* @__PURE__ */ n(ye, { size: "xs", className: _.stepLoader }) : l.props.icon,
          className: `${l.props.className || ""} ${d ? _.stepError : ""} ${m ? _.stepLoading : ""}`,
          "data-error": d || void 0,
          classNames: p(s({}, l.props.classNames), {
            stepIcon: `${_.stepIcon} ${d ? _.stepIconError : ""}`,
            stepLabel: `${_.stepLabel} ${d ? _.stepLabelError : ""}`
          })
        }));
      })
    })
  );
});
Je.displayName = "Stepper";
const Ye = w.Step;
Ye.displayName = "Step";
export {
  Ye as Step,
  Je as Stepper
};
